import { AdminPerson } from './Person';

export class WebappSession {
    constructor(data) {

        var self = this;
        self.type = "WebappSession";
        self.rootvm = data.rootvm;

        self.session_uuid = ko.observable(data.session_uuid);
        self.person_uuid = ko.observable(data.person_uuid);
        self.expires = ko.observable(data.expires);


        self.session_last_checked = ko.observable();

        self.update_self = function (data) {

            if (data.session) {
                self.session_uuid(data.session.session_uuid);
                self.person_uuid(data.session.person_uuid);
                self.expires(data.session.expires);

            }

            else {
                self.session_uuid(null);
                self.person_uuid(null);
                self.expires(null);
            }

            self.user().update_self(data);

        };

        self.get_session_status = function () {

            self.rootvm.syslog("Checking session");

            return $.ajax({
                url: "/api/session",
                type: "GET",
                success: function (data) {

                    self.session_last_checked(new Date());

                    if (data.success) {
                        self.rootvm.syslog(data.message);
                        self.update_self(data);
                    }
                }
            });

        };

        self.start_session = function () {

            self.rootvm.syslog("Starting session");

            return $.ajax({
                url: "/api/start-session",
                type: "POST",
                success: function (data) {
                    if (data.success) {
                        self.update_self(data);
                    }
                },
                complete: function () {
                    self.rootvm.syslog("Started session");
                }
            });
        };

        self.user = ko.observable(new AdminPerson({ rootvm: self.rootvm }));

        self.end_session = function () {

            self.rootvm.syslog("Ending session");

            return $.ajax({
                url: "/api/end-session",
                type: "POST",
                success: function (data) {

                    if (data.success) {
                        self.rootvm.syslog(data.message);
                        self.update_self(data);
                        self.user().navigate_here_after_login_success(null);
                        pager.navigate("/");
                    }

                },

                complete: function () {
                    self.rootvm.syslog("Ended session");
                }
            });
        };

    }
    toJSON() {

        var self = this;

        return {
            session_uuid: self.session_uuid(),
            person_uuid: self.person_uuid(),
            expires: self.expires(),
            user: self.user().toJSON()
        };

    }
};


